// Library imports
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export const useCustomerStore = create(
	persist(
		set => ({
			// Initial values for personal info
			// user_email: "",
			user_name: "",
			user_name_first: "",
			user_name_last: "",
			// user_number_mobile: "",
			user_nric: "",

			// Initial values for QR code data
			qr_code: "",
			agencies: [],
			instructions: "",

			// Reset store to defaults
			resetStore: () =>
				set({
					// user_email: "",
					user_name: "",
					user_name_first: "",
					user_name_last: "",
					// user_number_mobile: "",
					user_nric: "",
					qr_code: "",
					agencies: [],
					instructions: "",
				}),

			// Setters for personal info
			// setUserEmail: email => set({ user_email: email }),
			setUserName: name => set({ user_name: name }),
			setUserNameFirst: first => set({ user_name_first: first }),
			setUserNameLast: last => set({ user_name_last: last }),
			// setUserNumberMobile: mobile => set({ user_number_mobile: mobile }),
			setUserNric: nric => set({ user_nric: nric }),

			// Setters for QR code data
			setQrCode: qr_code => set({ qr_code: qr_code }),
			setAgencies: agencies => set({ agencies: agencies }),
			setInstructions: instructions => set({ instructions: instructions }),
		}),
		{
			name: "palmpass-user",
			storage: createJSONStorage(() => sessionStorage),
		}
	)
);
